$(document).ready(function(){
	
    //Template Portable Toilet
    //Pagination in Map section
    if($('#smartskip_region_map_section').length > 0){
        //Service Region Slider
        var activeClass = 'active',
            ariaAttribute = 'aria-hidden';
        $( '.service-region-slider' )
        .on( 'init', function() {
            $( '.slick-dots li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, false );
        } )
        .on( 'afterChange', function( event, slick, currentSlide ) {
            var $dots = $( '.slick-dots' );
            $( 'li', $dots ).removeClass( activeClass ).attr( ariaAttribute, true );
            $dots.each( function() {
                $( 'li', $( this ) ).eq( currentSlide ).addClass( activeClass ).attr( ariaAttribute, false );
            } );
        } );

         $(".service-region-slider").slick({
            rows: ($('.items_per_page').val() == '3') ? 1 : 2,
            infinite: false,
            slidesPerRow: 3,
            arrows: true,
            autoplay: false,
            dots: true,
            appendDots: $('.page-number'),
            prevArrow: '.previous',
            nextArrow: '.next',
            customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<a class="dot">'+(i+1)+'</a>';
                    },
            responsive: [{ 
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows: true,
                    dots: true,
                    slidesToScroll: 1,
                    slidesPerRow: 1,
                    rows : 1,
                } 
            }]
        });
    }
});